exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".addEditFixedSetDialog-paper {\n  overflow-y: initial !important; }\n\n.updateCustomer {\n  overflow: auto;\n  overflow-y: initial !important;\n  max-width: 500px;\n  padding-bottom: 0 !important;\n  padding: 8px 25px !important; }\n  .updateCustomer .select-search {\n    margin-bottom: 7px; }\n    .updateCustomer .select-search .react-select-text-field + div > div {\n      max-height: 200px; }\n  .updateCustomer .set-image {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n    justify-content: center; }\n\n@media only screen and (min-width: 768px) {\n  .updateCustomer {\n    min-width: 300px; } }\n\n/*\n@media only screen and (max-width: 767px) {\n    .updateCustomer {\n        overflow-x: hidden;\n    }\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/CustomersOrders/BillingDeliveryDetail/BillingDeliveryDetail.scss
// module id = 1684
// module chunks = 0